import { Group, Switch } from '@mantine/core';
import { _t } from 'lang';

/**
 * Show deleted objects switch.
 *
 * @param {{value: boolean; onChange: (val: boolean) => void}} props
 */
export default function ShowDeletedSwitch({ value, onChange }) {
  return (
    <Group position="right">
      <Switch
        checked={value}
        onChange={(e) => {
          onChange(e.currentTarget.checked);
        }}
        label={_t('Show deleted')}
        labelPosition="left"
      />
    </Group>
  );
}
